exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js??ref--6-oneOf-1-1!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/postcss-loader/src/index.js??ref--6-oneOf-1-2!../../../assets/less/index.less"), "");

// module
exports.push([module.id, "\n.anty-img-wrap[data-v-2a04ad98] {\n  height: 25px;\n  position: relative;\n}\n.anty-img-wrap > img[data-v-2a04ad98] {\n  max-height: 100%;\n}\n.marginCss[data-v-2a04ad98] {\n  margin-top: 20px;\n}\n", ""]);

// exports
